<template>
    <div>
        <b-modal :id="id" size="lg">
            <template v-slot:modal-header="{ close }">
                <h3 class="w-100 text-center">{{ title }}</h3>
                <button type="button" class="close" @click="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <template v-slot:default>
                <add-price-list-to-client-form
                    formId="add_price_list_to_client_form"
                    :mode="mode"
                    @closeModal="closeModal()"
                />
            </template>
            <template v-slot:modal-footer>
                <button
                    type="button"
                    class="btn btn-white"
                    @click="closeModal()"
                >
                    {{ __("close") }}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary"
                    form="add_price_list_to_client_form"
                >
                    {{ __("save") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import AddPriceListToClientForm from "./../forms/AddPriceListToClientForm/AddPriceListToClientForm";

export default {
    name: "modal-add-price-list-to-client",
    data() {
        return {};
    },
    components: {
        AddPriceListToClientForm
    },
    props: {
        id: {
            type: String,
            default: "modal"
        },
        title: String,
        mode: String
    },
    methods: {
        openModal() {
            this.$bvModal.show(this.id);
        },
        closeModal() {
            this.$bvModal.hide(this.id);
        }
    }
};
</script>
